import React, { useState } from 'react';
import { Form, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { User } from '../types/user';
import { getUserRPS } from '../services/api';
import { ENVIRONMENT } from '../environments';
import '../styles/Login.scss';

interface LoginProps {
    onLogin: (user: User) => void;
}

const Login: React.FC<LoginProps> = ({ onLogin }) => {
    const [user, setUser] = useState<User>({
        CodUser: '',
        Password: ''
    });
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const getEnvironment = () => {
        return ENVIRONMENT;
    };

    const environment = getEnvironment();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        e.stopPropagation();
        
        setError('');
        setLoading(true);

        try {
            console.log('Intentando login con:', user);
            const response = await getUserRPS(user);
            console.log('Respuesta del servidor:', response);

            if (!response.success) {
                throw new Error(response.data as string || 'Credenciales inválidas');
            }

            const userData = response.data as User;
            console.log('Datos del usuario:', userData);
            
            // Guardar la instancia de User generada
            const userInstance: User = {
                CodUser: userData.CodUser,
                Password: userData.Password,
                CodCompany: userData.CodCompany,
                Description: userData.Description
            };
            
            // Guardar en localStorage
            localStorage.setItem('userData', JSON.stringify(userInstance));
            
            // Actualizar la sesión y redirigir
            onLogin(userInstance);
            navigate('/contracts');
        } catch (err: any) {
            console.error('Error en login:', err);
            setError(err.message || 'Error al iniciar sesión. Por favor, verifica tus credenciales.');
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setUser(prev => ({
            ...prev,
            [name]: value
        }));
    };

    return (
        <div className="login-container">
            <div className="login-card">
                {environment && environment !== 'prod' && (
                    <div className="environment-badge">
                        {environment === 'dev' ? 'Desarrollo' : 
                         environment === 'pre' ? 'Preproducción' : environment}
                    </div>
                )}
                
                <div className="logo-container">
                    <img src="/assets/icono-novagric.png" alt="Logo Novagric" />
                </div>

                <h2 className="card-title">Iniciar Sesión</h2>
                
                {error && <Alert variant="danger">{error}</Alert>}
                
                <Form onSubmit={handleSubmit}>
                    <Form.Group className="mb-3">
                        <Form.Label>Usuario</Form.Label>
                        <Form.Control
                            type="text"
                            name="CodUser"
                            value={user.CodUser}
                            onChange={handleChange}
                            required
                            placeholder="Ingrese su usuario"
                        />
                    </Form.Group>

                    <Form.Group className="mb-4">
                        <Form.Label>Contraseña</Form.Label>
                        <Form.Control
                            type="password"
                            name="Password"
                            value={user.Password}
                            onChange={handleChange}
                            required
                            placeholder="Ingrese su contraseña"
                        />
                    </Form.Group>

                    <Button 
                        variant="primary" 
                        type="submit" 
                        className="w-100"
                        disabled={loading}
                    >
                        {loading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                    </Button>
                </Form>
            </div>
        </div>
    );
};

export default Login; 